import React from "react";
import PropTypes from "prop-types";

import { clx } from "../../../../utils/Helpers";
import GenderCount from "./index";

import "./GenderCount.scss";

const GenderCountsGroup = ({
  maleLabel,
  femaleLabel,
  maleCount,
  femaleCount,
  size,
  className,
}) => (
  <div
    className={clx(
      "gender-counts-group",
      { "gender-counts-group--sm": size === "sm" },
      className,
    )}
  >
    <GenderCount variant="male" label={maleLabel} count={maleCount} />
    <span className="gender-counts-group__divider" aria-hidden />
    <GenderCount variant="female" label={femaleLabel} count={femaleCount} />
  </div>
);

GenderCountsGroup.propTypes = {
  maleLabel: PropTypes.string.isRequired,
  femaleLabel: PropTypes.string.isRequired,
  maleCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  femaleCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** md: bordered pill with labels (event view); sm: bare icon + count (cards). */
  size: PropTypes.oneOf(["sm", "md"]),
  className: PropTypes.string,
};

GenderCountsGroup.defaultProps = {
  maleCount: 0,
  femaleCount: 0,
  size: "md",
  className: undefined,
};

export default GenderCountsGroup;
